import React from 'react';
import { observer } from 'mobx-react';

import { Container, Box, Paper, Button, IconButton, WarningCircleIcon, Typography } from '@availity/element';

import Header from '../Header';

import commonStore from '../../stores/CommonStore';

const ApplicationDown = () => {
  const { brand, inPublicfacingFlow } = commonStore;
  const { spaceId } = brand;

  const goToPayerSpaceLandingPage = () => {
    window.location.href = `/web/spc/spaces/#/${spaceId}`;
  };

  return (
    <Container id="application-down-container">
      <Box id="application-down-box">
        <Header commonStore={commonStore} id="header" />
        <Paper id="application-down-paper" sx={{ marginTop: 4, p: 4 }}>
          <Box id="application-down-content" sx={{ textAlign: 'center' }}>
            <IconButton id="warning-circle" color="secondary" sx={{ p: 0 }} aria-label="system-unavailable">
              <WarningCircleIcon fontSize="xlarge" />
            </IconButton>
            <Typography id="system-unavailable" variant="h3" sx={{ marginTop: 2, marginBottom: 1 }}>
              System Unavailable
            </Typography>
            <Typography id="text-summary" component="p" sx={{ marginBottom: 1 }}>
              We apologize for the inconvenience, but this application is currently unavailable. Please try again later.
            </Typography>
            {!inPublicfacingFlow && (
              <Button
                id="return-to-payer-spaces-page"
                color="primary"
                type="button"
                onClick={goToPayerSpaceLandingPage}
              >
                Return to Payer Spaces Landing Page
              </Button>
            )}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default observer(ApplicationDown);
